export type PasswordStrength = 'Weak' | 'Medium' | 'Strong';

export function getPasswordStrength(password: string): { level: PasswordStrength; score: number } {
    if (!password) return { level: 'Weak', score: 0 };

    const length = password.length;
    const hasUpper = /[A-Z]/.test(password);
    const hasLower = /[a-z]/.test(password);
    const hasDigit = /[0-9]/.test(password);
    const hasSymbol = /[^A-Za-z0-9]/.test(password);

    const criteriaCount = [hasUpper, hasLower, hasDigit, hasSymbol].filter(Boolean).length;

    // Strong: 8+ chars with ALL four complexity classes
    if (length >= 8 && hasUpper && hasLower && hasDigit && hasSymbol) {
        return { level: 'Strong', score: 3 };
    }

    // Medium: 8+ chars with at least some complexity (2+ classes)
    if (length >= 8 && criteriaCount >= 2) {
        return { level: 'Medium', score: 2 };
    }

    // Weak: less than 8 chars OR missing complexity
    return { level: 'Weak', score: 1 };
}

export function strengthToColor(level: PasswordStrength): string {
    switch (level) {
        case 'Strong':
            return 'strong';
        case 'Medium':
            return 'medium';
        default:
            return 'weak';
    }
}
